import styled, { keyframes } from 'styled-components';

// Implementacao do design Variaveis.html (handoff bundle
// 3eXLpn_dFimKG_lSs64cJg) — hairline shell pattern:
// page-header + filters 6-col + table 7-col grid + pager + modal de detalhe.
//
// Mantemos exports antigos (TableCard, FiltersCard, PaginationContainer,
// Label, DetailPanel, ...) como compat-aliases pra outros lugares que
// importam de aqui (ex.: register-variable). A tela em si usa os
// exports novos (PageHeader, Filters, Search, SelCell, Cta, Table,
// Th, Tr, Tc, TipoPill, StatusPill, RowActions, IconBtn, Pager).

// ============================================================
// Container
// ============================================================
export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: calc(100vw - 64px);
  min-height: 100vh;
  margin: 0 0 0 64px;
  padding: 0;
  box-sizing: border-box;
  background: var(--cco-bg);
  color: var(--cco-ink);
`;

// Wrapper agora envolve PageHeader + Filters (pass-through).
export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

// ============================================================
// Page Header (.ph) — titulo + sub + contador "X de Y variáveis"
// ============================================================
export const PageHeader = styled.section`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 14px;
  padding: 18px var(--cco-pad);
  border-bottom: 1px solid var(--cco-line);
`;

export const PageHeaderText = styled.div`
  display: flex;
  flex-direction: column;
`;

export const PageTitle = styled.h1`
  margin: 0;
  font-size: 22px;
  font-weight: 700;
  letter-spacing: -0.01em;
  color: var(--cco-ink);
`;

export const PageSub = styled.div`
  color: var(--cco-ink-mute);
  font-size: 13px;
  margin-top: 3px;
`;

export const PageCount = styled.div`
  font-size: 13px;
  color: var(--cco-ink-mute);
  font-variant-numeric: tabular-nums;

  b {
    color: var(--cco-ink);
    font-weight: 700;
  }
`;

// ============================================================
// Filters (.filters) — grid 6-col com hairlines
// busca | maquina | tipo | cliente | status | CTA
// ============================================================
export const Filters = styled.section`
  display: grid;
  grid-template-columns: 1fr 160px 160px 160px 160px auto;
  border-bottom: 1px solid var(--cco-line);

  > * + * {
    border-left: 1px solid var(--cco-line);
  }

  @media (max-width: 1200px) {
    grid-template-columns: 1fr 1fr 1fr;
    > * + * {
      border-left: 0;
    }
    > *:nth-child(3n) {
      border-right: 0;
    }
    > *:not(:nth-child(3n)) {
      border-right: 1px solid var(--cco-line);
    }
    > *:not(:nth-child(-n + 3)) {
      border-top: 1px solid var(--cco-line);
    }
    > .cta {
      grid-column: 1 / -1;
      border-right: 0;
    }
  }
`;

// Search cell — lupa svg + input transparente
export const Search = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 14px var(--cco-pad);

  svg {
    color: var(--cco-ink-mute);
    flex: none;
    width: 16px;
    height: 16px;
  }

  input {
    flex: 1;
    background: transparent;
    border: 0;
    outline: 0;
    color: var(--cco-ink);
    font: inherit;
    font-size: 14px;
    padding: 8px 0;
    min-width: 0;

    ::placeholder {
      color: var(--cco-ink-faint);
    }
  }
`;

// Sel cell — native select com seta SVG inline
export const SelCell = styled.div`
  display: flex;
  align-items: center;
  padding: 14px 18px;

  select {
    flex: 1;
    background-color: transparent;
    background: transparent;
    border: 0;
    outline: 0;
    color: var(--cco-ink);
    font: inherit;
    font-size: 13.5px;
    font-weight: 500;
    padding: 8px 22px 8px 0;
    appearance: none;
    cursor: pointer;
    width: 100%;
    min-width: 0;
    background-image: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='12' height='8' viewBox='0 0 12 8'><path fill='rgba(255,255,255,.4)' d='M0 0h12L6 8z'/></svg>");
    background-repeat: no-repeat;
    background-position: right 0 center;
  }

  select option {
    background-color: var(--cco-bg, #07090d);
    color: var(--cco-ink, #f4f7fb);
  }

  select option:checked {
    background-color: var(--cco-cyan, #1cb0d8);
    color: #071014;
  }
`;

// Cta button .cta — pill cyan-soft com .ic (square solid) + .tx (dual line)
export const Cta = styled.button.attrs({ className: 'cta' })`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 20px;
  background: rgba(28, 176, 216, 0.1);
  color: var(--cco-cyan);
  border: 0;
  transition: background 150ms ease;
  cursor: pointer;
  min-width: 230px;
  font-family: inherit;

  :hover {
    background: rgba(28, 176, 216, 0.18);
  }

  .ic {
    width: 34px;
    height: 34px;
    border-radius: 9px;
    background: var(--cco-cyan);
    color: #0a0a0b;
    display: grid;
    place-items: center;
    flex: none;

    svg {
      width: 18px;
      height: 18px;
    }
  }

  .tx {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    line-height: 1.25;
  }
  .tx .t {
    font-size: 14px;
    font-weight: 700;
    letter-spacing: 0.06em;
    text-transform: uppercase;
  }
  .tx .s {
    font-size: 11.5px;
    color: var(--cco-ink-mute);
    font-weight: 500;
  }
`;

// ============================================================
// Table (.table) — grid 7-col: Nome | Maquina(s) | Tipo |
// Unidade | Cliente(s) | Status | Acoes
// ============================================================
export const TableWrap = styled.section`
  flex: 1;
  display: flex;
  flex-direction: column;
  min-height: 0;
`;

export const Table = styled.div`
  display: grid;
  grid-template-columns: 1.5fr 1.8fr 1fr 0.8fr 1.4fr 1fr 1.2fr;
  align-items: stretch;

  /* Card layout no mobile — mesma logica de machines/stations/customers
     /users. Table vira flex coluna; cada Tr (filho direto) e um card. */
  @media (max-width: 720px) {
    display: flex;
    flex-direction: column;
  }
`;

export const Th = styled.div`
  padding: 14px var(--cco-pad);
  color: var(--cco-ink);
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.04em;
  border-bottom: 1px solid var(--cco-line);
  display: flex;
  align-items: center;
  gap: 6px;
  cursor: ${(props) => (props.$sortable ? 'pointer' : 'default')};
  user-select: none;

  .sort {
    color: var(--cco-ink-faint);
    font-size: 10px;
    display: inline-flex;
    align-items: center;
  }

  :hover .sort {
    ${(props) => props.$sortable && 'color: var(--cco-ink-mute);'}
  }

  /* No mobile o label do header vira inline em cada Tc — Th some pra
     nao duplicar. */
  @media (max-width: 720px) {
    display: none;
  }
`;

// Tr — display:contents pra cada filho ir direto pro grid pai
export const Tr = styled.div`
  display: contents;

  :hover .tc {
    background: rgba(255, 255, 255, 0.02);
  }

  @media (max-width: 720px) {
    display: flex;
    flex-direction: column;
    padding: 14px var(--cco-pad);
    border-bottom: 1px solid var(--cco-line);
    gap: 4px;
  }
`;

export const Tc = styled.div.attrs({ className: 'tc' })`
  padding: 14px var(--cco-pad);
  border-bottom: 1px solid var(--cco-line);
  display: flex;
  align-items: center;
  transition: background 120ms ease;
  min-width: 0;
  gap: 8px;

  @media (max-width: 720px) {
    padding: 4px 0;
    border-bottom: 0;
    justify-content: flex-start;

    /* Label inline (data-label do JSX) — vira "TIPO: <valor>" estilo
       card. */
    &::before {
      content: attr(data-label);
      color: var(--cco-ink-mute);
      font-size: 10px;
      font-weight: 700;
      letter-spacing: 0.14em;
      text-transform: uppercase;
      margin-right: 8px;
      min-width: 90px;
      flex-shrink: 0;
    }
  }
`;

export const TcNome = styled(Tc)`
  font-weight: 700;
  color: var(--cco-ink);
  font-size: 14px;
`;

export const TcUnidade = styled(Tc)`
  color: var(--cco-ink);
  font-size: 13.5px;
  font-family: 'JetBrains Mono', monospace;
`;

// Badges container pra primary text + "+N" overflow
export const Badges = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  flex-wrap: wrap;
  min-width: 0;
`;

export const Primary = styled.span`
  color: var(--cco-ink);
  font-weight: 600;
  font-size: 13px;
  letter-spacing: 0.02em;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
`;

export const More = styled.span`
  display: inline-flex;
  align-items: center;
  padding: 3px 8px;
  border-radius: 6px;
  background: rgba(255, 255, 255, 0.06);
  color: var(--cco-ink-mute);
  font-size: 11px;
  font-weight: 700;
  font-variant-numeric: tabular-nums;
  flex: none;
`;

// Tipo pill (.tipo-pill) — cyan solido por padrao
export const TipoPill = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 32px;
  padding: 0 20px;
  min-width: 130px;
  background: var(--cco-cyan);
  color: #06151a;
  font-size: 12.5px;
  font-weight: 700;
  letter-spacing: 0.02em;
  border-radius: 999px;
  text-transform: lowercase;
  white-space: nowrap;
`;

// Status pill (.status-pill) — ok/fail/pend
export const StatusPill = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 32px;
  padding: 0 22px;
  min-width: 130px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.04em;
  white-space: nowrap;

  ${(props) =>
    props.$status === 'Verificada' &&
    `background: var(--cco-green); color: #06281a;`}
  ${(props) =>
    props.$status === 'Falha' &&
    `background: var(--cco-red); color: #fff;`}
  ${(props) =>
    (props.$status === 'Pendente' || !props.$status) &&
    `background: var(--cco-yellow); color: #1a1408;`}
`;

// Row actions — 30x30 icon buttons
export const RowActions = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
`;

export const IconBtn = styled.button`
  width: 30px;
  height: 30px;
  /* Touch target >=44px no mobile (WCAG 2.5.5 / Apple HIG). */
  @media (max-width: 720px) {
    min-width: 44px;
    min-height: 44px;
  }
  border-radius: 8px;
  background: transparent;
  border: 0;
  display: grid;
  place-items: center;
  color: ${(props) => props.color || 'var(--cco-ink-mute)'};
  transition: all 150ms ease;
  cursor: pointer;
  font-family: inherit;

  :hover:not(:disabled) {
    color: var(--cco-cyan);
    background: rgba(28, 176, 216, 0.08);
  }

  &.danger:hover:not(:disabled) {
    color: var(--cco-red);
    background: var(--cco-red-soft, rgba(244, 68, 92, 0.14));
  }

  &.refresh {
    color: var(--cco-orange);
  }
  &.refresh:hover:not(:disabled) {
    background: rgba(241, 162, 91, 0.1);
    color: var(--cco-orange);
  }

  :disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  ${(props) =>
    props.$spinning &&
    `
    svg { animation: var-spin 1s linear infinite; }
    @keyframes var-spin {
      from { transform: rotate(0deg); }
      to   { transform: rotate(360deg); }
    }
  `}
`;

// Empty row (full-width across all 7 cols)
export const EmptyRow = styled.div`
  grid-column: 1 / -1;
  padding: 60px 0;
  text-align: center;
  color: var(--cco-ink-faint);
`;

// Skeleton row pra loading
const shimmer = keyframes`
  0%   { background-position: -200% 0; }
  100% { background-position: 200% 0; }
`;

export const SkeletonCell = styled(Tc)`
  ::before {
    content: '';
    display: block;
    width: ${(props) => props.$w || '70%'};
    height: 14px;
    border-radius: 6px;
    background: linear-gradient(
      90deg,
      rgba(255, 255, 255, 0.04) 0%,
      rgba(255, 255, 255, 0.08) 50%,
      rgba(255, 255, 255, 0.04) 100%
    );
    background-size: 200% 100%;
    animation: ${shimmer} 1.4s ease-in-out infinite;
  }
`;

// ============================================================
// Pager (.pager) — Anterior / 1 2 3 ... 45 46 47 / Proximo + exibir N
// ============================================================
export const Pager = styled.section`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 14px;
  padding: 20px var(--cco-pad);
  border-top: 1px solid var(--cco-line);
  flex-wrap: wrap;

  .btn {
    height: 36px;
    padding: 0 18px;
    border-radius: 9px;
    background: rgba(255, 255, 255, 0.04);
    border: 1px solid var(--cco-line);
    color: var(--cco-ink);
    font-size: 12.5px;
    font-weight: 600;
    letter-spacing: 0.04em;
    transition: all 150ms ease;
    cursor: pointer;
    font-family: inherit;
  }
  .btn:hover:not(:disabled) {
    background: rgba(255, 255, 255, 0.08);
  }
  .btn:disabled {
    opacity: 0.45;
    cursor: not-allowed;
  }

  .pages {
    display: flex;
    gap: 6px;
    align-items: center;
  }
  .pg {
    width: 36px;
    height: 36px;
    border-radius: 9px;
    display: grid;
    place-items: center;
    background: rgba(255, 255, 255, 0.04);
    border: 1px solid var(--cco-line);
    color: var(--cco-ink);
    font-size: 13.5px;
    font-weight: 600;
    transition: all 150ms ease;
    cursor: pointer;
    font-family: inherit;
  }
  .pg.on {
    background: var(--cco-cyan);
    border-color: var(--cco-cyan);
    color: #0a0a0b;
  }
  .pg:not(.on):hover {
    background: rgba(255, 255, 255, 0.08);
  }
  .dots {
    color: var(--cco-ink-mute);
    padding: 0 4px;
    font-weight: 700;
  }
  .exhibit {
    display: flex;
    align-items: center;
    gap: 10px;
    color: var(--cco-ink-mute);
    font-size: 12.5px;
  }
  .exhibit select {
    height: 32px;
    padding: 0 28px 0 12px;
    border-radius: 8px;
    background: rgba(255, 255, 255, 0.04);
    border: 1px solid var(--cco-line);
    color: var(--cco-ink);
    font-size: 13px;
    cursor: pointer;
    appearance: none;
    background-image: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='10' height='6' viewBox='0 0 10 6'><path fill='rgba(255,255,255,.4)' d='M0 0h10L5 6z'/></svg>");
    background-repeat: no-repeat;
    background-position: right 8px center;
    font-family: inherit;
  }
`;

// ============================================================
// Detail Panel (modal de detalhes da variavel — preservado do velho)
// ============================================================
export const DetailBackdrop = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.55);
  backdrop-filter: blur(4px);
  z-index: 50;
`;

export const DetailPanel = styled.div`
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 51;
  width: min(880px, calc(100vw - 48px));
  max-height: calc(100vh - 48px);
  background: var(--cco-surface);
  border: 1px solid var(--cco-line-strong);
  border-radius: 16px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
`;

export const DetailHeader = styled.header`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 18px 24px;
  border-bottom: 1px solid var(--cco-line);
`;

export const DetailTitle = styled.h3`
  margin: 0;
  font-size: 17px;
  font-weight: 700;
  color: var(--cco-ink);
  letter-spacing: -0.01em;
`;

export const DetailSubtitle = styled.span`
  font-size: 12px;
  color: var(--cco-ink-mute);
  margin-top: 3px;
  display: block;
`;

export const DetailCloseButton = styled.button`
  width: 34px;
  height: 34px;
  border-radius: 10px;
  background: transparent;
  border: 0;
  box-shadow: inset 0 0 0 1px var(--cco-line-strong);
  color: var(--cco-ink-mute);
  display: grid;
  place-items: center;
  cursor: pointer;
  transition: all 150ms ease;
  font-family: inherit;

  :hover {
    background: rgba(244, 68, 92, 0.1);
    color: var(--cco-red);
    box-shadow: inset 0 0 0 1px rgba(244, 68, 92, 0.4);
  }
`;

export const DetailBody = styled.div`
  padding: 24px;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

export const DetailSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

export const DetailSectionLabel = styled.span`
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: var(--cco-ink-mute);
`;

export const DetailSectionValue = styled.span`
  font-size: 14px;
  color: var(--cco-ink);
`;

export const DetailGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 18px;
`;

export const DetailRangeList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  max-height: 320px;
  overflow-y: auto;
`;

export const DetailRangeItem = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  padding: 10px 12px;
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.025);
  border: 1px solid var(--cco-line);
`;

export const DetailRangePrimary = styled.span`
  font-size: 13.5px;
  font-weight: 600;
  color: var(--cco-ink);
`;

export const DetailRangeMeta = styled.span`
  font-size: 12px;
  color: var(--cco-ink-mute);
`;

// ============================================================
// Compat exports — pra register-variable e outros lugares.
// Mantemos os nomes antigos mapeando pros novos exports do design.
// ============================================================
export const FiltersCard = Filters;
export const TableCard = TableWrap;
export const TableContainer = Table;
export const TableHeader = Th;
export const SortableHeader = Th;
export const TableBody = styled.div`
  display: contents;
`;
export const TableRow = Tr;
export const CellStrong = Primary;
export const CellMuted = Primary;
export const Badge = More;
export const TypeBadge = TipoPill;
export const StatusBadge = StatusPill;
export const Actions = RowActions;
export const ActionButton = IconBtn;
export const EmptyState = EmptyRow;
export const SkeletonRow = Tr;
export const PaginationContainer = Pager;
export const Label = styled.span`
  font-size: 12.5px;
  color: var(--cco-ink-mute);
`;
export const ClearFiltersButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 7px 12px;
  border-radius: 8px;
  background: transparent;
  border: 1px solid var(--cco-line);
  color: var(--cco-ink-mute);
  font-size: 11.5px;
  font-weight: 600;
  cursor: pointer;
  transition: all 150ms ease;
  font-family: inherit;

  :hover {
    background: rgba(255, 255, 255, 0.04);
    color: var(--cco-ink);
  }
`;
export const ButtonCadastro = Cta;
export const ButtonDiv = styled.div``;
export const IconNew = styled.img``;
export const LabelCadastro = styled.span``;
